// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__LjAAp","boxTitle":"Qualiphy_boxTitle__21AKd","box":"Qualiphy_box__2hr9O","toggleWrap":"Qualiphy_toggleWrap__sMQtE"};